<template>
  <div class="r-form__field">
    <label
      v-if="!hideLabel"
      class="control-label"
    >
      {{ label }}
      <span v-if="isRequired">*</span>
      <i 
        v-if="hasTooltip"
        v-tooltip.right="tooltipText"
        class="fa fa-question-circle m-l-5"
      />
    </label>
    <div
      class="r-form__input"
      :class="inputClasses"
    >
      <slot name="input" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFormFieldV2',
  props: {
    label: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hasTooltip: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: ''
    },
    inputClasses: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: false
    },
  }
};
</script>